import { render, staticRenderFns } from "./Part2Layout.vue?vue&type=template&id=979da79c&scoped=true"
import script from "./Part2Layout.vue?vue&type=script&lang=ts"
export * from "./Part2Layout.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=979da79c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979da79c",
  null
  
)

export default component.exports